<template>
  <div ref="background" class="video-background-wrapper">
    <VideoBackground/>
  </div>
</template>

<script>
import VideoBackground from "../assets/svg/video-background.svg";

export default {
  name: "JourneyStep",
  components: {
    VideoBackground
  },
  props: {
      'color': {
          type: String,
          default: function () {
              return '#000'
          }
      }
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {},
    init() {
      this.$refs.background.querySelector('.background-primary').setAttribute('fill',this.color);
    }
  },
};
</script>

<style scoped lang="scss">
.video-background-wrapper > svg {
    width: 100%;
    height: 100%;
}
</style>